import { render, staticRenderFns } from "./mate-part.vue?vue&type=template&id=62b1bda6&scoped=true"
import script from "./mate-part.vue?vue&type=script&lang=js"
export * from "./mate-part.vue?vue&type=script&lang=js"
import style0 from "./mate-part.vue?vue&type=style&index=0&id=62b1bda6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1bda6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b1bda6')) {
      api.createRecord('62b1bda6', component.options)
    } else {
      api.reload('62b1bda6', component.options)
    }
    module.hot.accept("./mate-part.vue?vue&type=template&id=62b1bda6&scoped=true", function () {
      api.rerender('62b1bda6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/mate-part/mate-part.vue"
export default component.exports